
/**
 * Converts a raw field name or string into a human-readable label.
 * 
 * Examples:
 * - "players_data.age" -> "Age"
 * - "outside_area" -> "Outside Area"
 * - "sum" -> "Sum"
 * 
 * @param text The raw string to clean
 * @returns The cleaned, capitalized string
 */
export function cleanLabel(text: string): string {
    if (!text) return '';

    // 1. Remove table prefixes (e.g., "table_name.column" -> "column")
    const parts = text.split('.');
    let label = parts[parts.length - 1];

    // 2. Replace underscores and dashes with spaces
    label = label.replace(/[_-]/g, ' ');

    // 3. Capitalize first letter of each word
    label = label.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));

    return label;
}
